var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"flat":"","icon":"","color":_vm.getColor}},[_c('v-icon',{on:{"click":_vm.toggle}},[_vm._v("filter_list")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }